import API from "./API";

class Location {
  static async all() {
    return API.get("/merchant/locations/", { needAuth: true });
  }

  static async get(id) {
    return API.get(`/merchant/locations/${id}`, { needAuth: true });
  }

  static async create(data) {
    return API.post("/merchant/locations/", data, { needAuth: true });
  }

  static async update(id, data) {
    return API.put(`/merchant/locations/${id}`, data, { needAuth: true });
  }
}

export default Location;
